import { useDispatch, useSelector } from 'react-redux';

import { persistor, store } from 'app/store';

import type { GetValue, RootState, SetValue, UseReduxToolkit } from './types';

const useReduxToolkit: UseReduxToolkit = ({ namespace }) => {
    const dispatch = useDispatch();

    const clearStore = () => {
        persistor?.purge();
    };

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const namespacedStore = useSelector((store: RootState) => (store as any)[namespace]);

    const getValue: GetValue = type => namespacedStore[type];

    const setValue: SetValue = keyValue => {
        const [[key, value]] = Object.entries(keyValue);

        dispatch({ payload: value, type: `${namespace}/${key}` });
    };

    return {
        clear: clearStore,
        getValue,
        setValue,
        store
    };
};

export default useReduxToolkit;
